import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './state';
import * as reducers from './reducers';

const employeesSlice = createSlice({
  initialState,
  reducers,
  name: 'employees',
});

export const { setCurrentEmployee } = employeesSlice.actions;

export default employeesSlice.reducer;
